module.exports = __webpack_public_path__ + "static/media/chapter2Next.84a92a6a.jpg";